import BaseAPIClient from './base/BaseAPIClient';

export default class PromptsClient extends BaseAPIClient {
  async getPrompts(userId) {
    const response = await this._get('v2/platform/prompts/', { userId });

    return response.prompts;
  }
  completePrompts(userId, prompt) {
    return this._post('v2/platform/prompts/complete', { userId, prompt });
  }
  createPrompt(userId, prompt) {
    return this._post('v2/platform/prompts/create', { userId, prompt });
  }
}